import { memo } from 'react';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Image from 'components/Image';
import styles from './ProductHero.module.scss';

const ProductHeroAlternateImages = memo(function ({
  className,
  images,
  imagesLength,
  largeImage,
  playVideo,
  productName,
  setLargeImage,
}) {
  return (
    <ul
      className={classNames(
        `list-unstyled m-0 mb-15 mb-sm-21 mb-lg-0 mt-8 mt-xl-0 overflow-auto px-8 px-lg-15 px-xl-0`,
        styles.alternate_image_list,
        className
      )}
    >
      {images.map(({ dimensions, label, url, videoUrl }, index) => {
        return (
          <li
            key={url}
            className={classNames(
              'd-inline-block d-xl-block mb-4 mb-xl-10 me-5 me-xl-0',
              styles.alternate_image,
              {
                [styles.selected_image]: url === largeImage.url,
              }
            )}
            data-value="product-hero-image"
          >
            <button
              className="d-block bg-transparent border-0 h-100 position-relative w-100"
              type="button"
              onClick={() =>
                videoUrl
                  ? playVideo(videoUrl)
                  : setLargeImage({ dimensions, url })
              }
            >
              <Image
                fill
                priority
                alt={
                  videoUrl
                    ? `Play Video: ${label}`
                    : `${productName}, ${index + 1} of ${imagesLength}`
                }
                src={url}
                objectFit="contain"
                sizes="(max-width: 991px) 20vw, 10vw"
              />

              {videoUrl ? (
                <span
                  className={classNames(
                    'd-inline-block position-absolute',
                    styles.video_icon
                  )}
                >
                  <FontAwesomeIcon
                    className="text-primary"
                    icon={faCirclePlay}
                  />{' '}
                </span>
              ) : null}
            </button>
          </li>
        );
      })}
    </ul>
  );
});

export default ProductHeroAlternateImages;
